var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-right":"10px"}},[_c('el-button',{attrs:{"disabled":_vm.canClick,"size":"mini","type":"primary","icon":"el-icon-download"},on:{"click":_vm.batchDownload}},[_vm._v("一键下载")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }